module.exports = __webpack_public_path__ + "static/media/Teampic.2c36403c.png";